export const tokens = {
  surfaceBase: '#030712',
  surfaceSunken: '#0a0b0f',
  surface: '#111318',
  surfaceElevated: '#1a1d24',
  surfaceOverlay: '#252830',
  border: '#252830',
  borderStrong: '#3a3e48',
  textPrimary: '#e5e7eb',
  textSecondary: '#b0b4be',
  textTertiary: '#8b8f9a',
  textQuaternary: '#5c616e',
  accent: '#3b82f6',
  accentHover: '#60a5fa',
  accentStrong: '#2563eb',
  accentPressed: 'oklch(48.8% 0.243 264.376)',
  statusSuccess: '#4ade80',
  statusSuccessStrong: '#22c55e',
  statusWarning: '#facc15',
  statusWarningStrong: '#eab308',
  statusWarningMuted: '#eab30833',
  statusDanger: '#f87171',
  statusDangerStrong: '#ef4444',
  statusInfo: '#60a5fa',
  statusNeutral: '#8b8f9a',
  bannerWarning: 'oklch(76.9% 0.188 70.08)',
  bannerWarningText: 'oklch(92.4% 0.12 95.746)',
  bannerWarningIcon: 'oklch(82.8% 0.189 84.429)',
  bannerSuccess: 'oklch(69.6% 0.17 162.48)',
  bannerSuccessText: 'oklch(90.5% 0.093 164.15)',
  bannerSuccessIcon: 'oklch(76.5% 0.177 163.223)',
  bannerInfoText: 'oklch(88.2% 0.059 254.128)',
  bannerErrorText: 'oklch(88.5% 0.062 18.334)',
  tileSelectedText: 'oklch(21% 0.006 285.885)',
  tileSelectedMuted: 'oklch(55.2% 0.016 285.938)',
  sportRunning: '#4ade80',
  sportCycling: '#f97316',
  mapShadow: '#000000',
  mapHighlight: '#ffffff',
  mapHillshadeHighlight: '#ffffff1a',
  mapDotStroke: '#00000050',
  chartFitness: '#3b82f6',
  chartFatigue: '#ec4899',
  chartForm: '#eab308',
  chartHr: '#ef4444',
  chartPower: '#3b82f6',
  chartSpeed: '#22c55e',
  chartGrade: '#a78bfa',
  chartCadence: '#f59e0b',
  chartElevation: '#8b5cf6',
  chartClimb: '#c4b5fd',
  chartPace: '#06b6d4',
  chartGap: '#ec4899',

  precipRain: '#60a5fa',
  precipFreezing: '#67e8f9',
  precipSnow: '#e5e7eb',
  precipThunderstorm: '#fbbf24',

  windTail: '#34d399',
  windCross: '#fbbf24',
  windHead: '#ef4444',

  routeFuchsia: '#e879f9',
  routeEmerald: '#34d399',
  routeAmber: '#fbbf24',
  routeViolet: '#a78bfa',
  routeOrange: '#f97316',
  routeRose: '#fb7185',

  zoneSlate: '#94a3b8',
  zoneBlue: '#60a5fa',
  zoneEmerald: '#34d399',
  zoneAmber: '#fbbf24',
  zoneOrange: '#f97316',
  zoneRed: '#ef4444',
  zoneCrimson: '#dc2626',
  zoneUnknown: '#888888',

  guideBaseline: '#ffffff1a',
  guideHover: '#ffffff40',
  guideToday: '#ffffff14',

  typeFeature: '#38bdf8',
  typeBug: '#fb7185',
  typeChore: '#a3e635',

  white: '#ffffff',
  white4: 'rgb(255 255 255 / 0.04)',
  white10: 'rgb(255 255 255 / 0.1)',
  white18: 'rgb(255 255 255 / 0.18)',
  white22: 'rgb(255 255 255 / 0.22)',
  white25: 'rgb(255 255 255 / 0.25)',
  white30: 'rgb(255 255 255 / 0.3)',
  white32: 'rgb(255 255 255 / 0.32)',
  white35: 'rgb(255 255 255 / 0.35)',
  white45: 'rgb(255 255 255 / 0.45)',
  white50: 'rgb(255 255 255 / 0.5)',
  white60: 'rgb(255 255 255 / 0.6)',
  white75: 'rgb(255 255 255 / 0.75)',
  white95: 'rgb(255 255 255 / 0.95)',
} as const;

export type TokenColor = (typeof tokens)[keyof typeof tokens];

export const fontSizes = { '2xs': 11, '3xs': 9 } as const;
